// import { dataUpload } from '../../firestoreData/dataUpload';

import { deleteField } from "firebase/firestore"
import _ from 'lodash'
import { removeFcmTokenFromTokens, updateAppUserProfile } from "../../firestoreData/profiles/updateProfiles"

export const _topicCollection = '_topics'

export const rts = {
  handleSet_dbTopics: 'handleSet_dbTopics',
  handleSet_topicSubscriptions: 'handleSet_topicSubscriptions',
  handleEmails: 'handleEmails',
  handleProfiles: 'handleProfiles',
  handleSubscribe: 'handleSubscribe',
  handleSubscribeToTopic: 'handleSubscribeToTopic',
  handleTopicFcms: 'handleTopicFcms',
  handleResponse_fcmSend: 'handleResponse_fcmSend',
  handleResponse_fcmClear: 'handleResponse_fcmClear',
  handleResponse_fcmSubscribe: 'handleResponse_fcmSubscribe',
  handleClear_fcm: 'handleClear_fcm',
  handlePending_start: 'handlePending_start',
  handlePending_clear: 'handlePending_clear',
}

export const topicReducer = (state, action) => {

  const { database_fns, fn_cls, profiles, pathViews } = state
  const { type, dispatch } = action

  const _pending = state.pending ? { ...state.pending } : {}

  const { handleResponse_fcmSubscribe, handleResponse_fcmSend, handleResponse_fcmClear } = topicHandlers(dispatch)

  switch (type) {

    case rts.handleSubscribeToTopic:

      const cb_subscribe = (r) => {
        const { success } = r ?? {}
        console.log('r', r)
        let _confirmation = getFcmComfirmation(success)
        handleResponse_fcmSend(_confirmation)
      }

      handleSubscribeToTopic(fn_cls, action, cb_subscribe)
      return { ...state }

    case rts.handleSubscribe:
      if (action.fcmTokens) {
        const _tokens = []
        Object.keys(action.fcmTokens).forEach(k => {
          _tokens.push(action.fcmTokens[k].tokenKey)
        })
        handleUpdateTopics(fn_cls, _tokens, action.topic, pathViews, action.unsubscribe, handleResponse_fcmSubscribe)
      } else {
        handleUpdateProfilesTopics(fn_cls, profiles, action.topic, pathViews, action.unsubscribe, handleResponse_fcmSubscribe)
      }
      return { ...state }

    case rts.handleResponse_fcmSend:
      const { confirmation } = action
      _pending.result = confirmation.success ? 'SUCCESS' : 'FAIL'
      return { ...state, confirmation: action.confirmation, pending: _pending }

    case rts.handleResponse_fcmSubscribe:
      const { result } = action
      _pending.result = result.success ? 'SUCCESS' : 'FAIL'
      return { ...state, pending: _pending }

    case rts.handleResponse_fcmClear:
      return { ...state, updating: null }

    case rts.handlePending_start:
      return { ...state, updating: true, pending: action.pending }

    case rts.handlePending_clear:
      return { ...state, updating: false, pending: null }

    case rts.handleProfiles:
      return { ...state, profiles: action.profiles }

    case rts.handleEmails:
      return { ...state, emails: action.emails }

    case rts.handleSet_dbTopics:
      return { ...state, dbTopics: action.dbTopics }

    case rts.handleSet_topicSubscriptions:
      return { ...state, topicSubscriptions: action.topicSubscriptions }

    case rts.handleTopicFcms:
      return { ...state, topicFcms: action.topicFcms }

    case rts.handleClear_fcm:

      const cb_clear = (res1) => {
        removeFcmTokenFromTokens(state.dbTopics, action.tokenKey, pathViews, _topicCollection).then(res2 => {
          handleResponse_fcmClear(res1, res2)
        })
      }

      const dataToUpdate = { fcmTokens: action.fcmTokens }
      if (_.isEmpty(dataToUpdate.fcmTokens)) { dataToUpdate.fcmTokens = deleteField() }

      updateAppUserProfile(database_fns, action.appUserKey, dataToUpdate, cb_clear)
      return { ...state }

    default:
      return { ...state }
  }
}

export const topicInitialState = (initState) => {
  return { ...initState }
};

export const topicHandlers = (dispatch, state) => {
  return {
    handleClear_fcm: (appUserKey, fcmTokens, tokenType, tokenKey) => { dispatch({ type: rts.handleClear_fcm, dispatch, appUserKey, fcmTokens, tokenType, tokenKey }) },
    handleEmails: (emails) => { dispatch({ type: rts.handleEmails, dispatch, emails }) },
    handlePending_clear: () => { dispatch({ type: rts.handlePending_clear, dispatch }) },
    handlePending_start: (pending) => { dispatch({ type: rts.handlePending_start, dispatch, pending }) },
    handleProfiles: (profiles) => { dispatch({ type: rts.handleProfiles, dispatch, profiles }) },
    handleResponse_fcmClear: (res1, res2) => { dispatch({ type: rts.handleResponse_fcmClear, dispatch, res1, res2 }) },
    handleResponse_fcmSend: (confirmation) => { dispatch({ type: rts.handleResponse_fcmSend, dispatch, confirmation }) },
    handleResponse_fcmSubscribe: (result) => { dispatch({ type: rts.handleResponse_fcmSubscribe, dispatch, result }) },
    handleSet_dbTopics: (dbTopics) => { dispatch({ type: rts.handleSet_dbTopics, dispatch, dbTopics }) },
    handleSet_topicSubscriptions: (topicSubscriptions) => { dispatch({ type: rts.handleSet_topicSubscriptions, dispatch, topicSubscriptions }) },
    handleSubscribe: (topic, fcmTokens, unsubscribe) => { dispatch({ type: rts.handleSubscribe, dispatch, topic, fcmTokens, unsubscribe }) },
    handleSubscribeToTopic: (token, topicKey, unsubscribe, itemKey, callback) => { dispatch({ type: rts.handleSubscribeToTopic, dispatch, token, topicKey, unsubscribe, itemKey, callback }) },
    handleTopicFcms: (topicFcms) => { dispatch({ type: rts.handleTopicFcms, dispatch, topicFcms }) },
  }
}

const handleSubscribeToTopic = (fn_cls, action, callback) => {
  const { token, topicKey, unsubscribe, itemKey } = action
  fn_cls.subscribeToTopic(token, topicKey, unsubscribe, itemKey).then(res => {
    callback && callback(res)
  })
}

const handleUpdateTopics = (fn_cls, _tokens, selectedTopic, pathViews, unsubscribe, callback) => {
  fn_cls.addTopicToFcmTokens(_tokens, selectedTopic, unsubscribe, pathViews, true).then(res => {
    callback(res)
  })
}

const handleUpdateProfilesTopics = (fn_cls, profiles, selectedTopic, pathViews, unsubscribe, callback) => {
  const _fcmProfiles = profiles ? _.filter(profiles, 'fcmTokens') : []
  const _fcmTokens = []
  if (_fcmProfiles) {
    _fcmProfiles.forEach(fcmProfile => {
      const { fcmTokens } = fcmProfile ?? {}
      if (fcmTokens) {
        Object.keys(fcmTokens).forEach(fk => {
          const fcmToken = fcmTokens[fk]
          if (fcmToken.tokenKey) {
            _fcmTokens.push(fcmToken.tokenKey)
          }
        })
      }
    })
  }
  fn_cls.addTopicToFcmTokens(_fcmTokens, selectedTopic, unsubscribe, pathViews, true).then(res => {
    callback()
  })
}

const getFcmComfirmation = (success) => {
  const _confirmation = {
    title: success ? 'Sent' : 'Not Sent',
    success: success ? true : false,
    content: success ? 'The Push Notification has been sent' : 'The Push Notification has NOT been sent',
  }
  return _confirmation
}